import { render, staticRenderFns } from "./OpenPrivateDm.vue?vue&type=template&id=091ec826&scoped=true"
import script from "./OpenPrivateDm.vue?vue&type=script&lang=js"
export * from "./OpenPrivateDm.vue?vue&type=script&lang=js"
import style0 from "./OpenPrivateDm.vue?vue&type=style&index=0&id=091ec826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091ec826",
  null
  
)

export default component.exports